<script setup lang="ts">
import type { ButtonProps } from '#layers/ui/components/Button.vue';
import DButton from '#layers/ui/components/Button.vue';
import DTooltip from '#layers/ui/components/Tooltip.vue';

interface Props extends Pick<ButtonProps, 'size' | 'variant' | 'disabled'> {
	label: string;
	readonly?: boolean;
	block?: boolean;
	isEmpty?: boolean;
	canClear?: boolean;
	showIcon?: boolean;
	showDisclosure?: boolean;
	dataTestid?: string;
	clearDataTestid?: string;
}

const {
	block = true,
	showIcon = true,
	showDisclosure = true,
	variant = 'outline',
	dataTestid = 'picker-trigger',
	clearDataTestid = 'picker-trigger-clear',
} = defineProps<Props>();

const emit = defineEmits<{
	clear: [];
}>();
</script>

<template>
	<DButton
		type="button"
		:leading-icon="showIcon ? 'lucide:calendar' : undefined"
		:trailing-icon="showDisclosure && !readonly && !canClear ? 'lucide:chevron-down' : undefined"
		color="neutral"
		:variant
		:size
		:disabled
		:data-testid
		:block
		:readonly
		:aria-readonly="readonly"
		:ui="{
			base: 'justify-between font-medium',
			label: 'flex-1 truncate text-start',
		}"
		:class="{ 'cursor-pointer': !readonly && !disabled }"
	>
		<span class="flex-1 truncate text-start" :class="{ 'text-dimmed': isEmpty }">{{ label }}</span>

		<template v-if="canClear && !readonly" #trailing>
			<DTooltip :text="$t('common.clear')">
				<DButton
					type="button"
					class="p-0 text-dimmed"
					color="neutral"
					variant="link"
					icon="lucide:x"
					size="sm"
					:data-testid="clearDataTestid"
					:disabled
					@click.stop="emit('clear')"
					@pointerdown.stop
				/>
			</DTooltip>
		</template>
	</DButton>
</template>
